<template>
    <single-article :article="article" :breadcrumbs="breadcrumbs" />
</template>

<script>
import { StatusCodes } from 'http-status-codes';

import SingleArticle from '@/components/articles/SingleArticle';

export default {
    components: {
        SingleArticle
    },

    async asyncData({
        error,
        store: { dispatch },
        params: { slug = null },
        query: { preview, uuid }
    }) {
        try {
            const params = {
                preview,
                uuid
            };

            const { article } = await dispatch('medicationCategories/show', {
                id: slug,
                params
            });

            return {
                article
            };
        } catch (err) {
            if (err.response?.status !== StatusCodes.INTERNAL_SERVER_ERROR) {
                return error({ statusCode: err.response.status });
            }

            console.error(err);

            return error({ statusCode: StatusCodes.INTERNAL_SERVER_ERROR });
        }
    },

    computed: {
        breadcrumbs() {
            return [
                {
                    text: this.$t('homepage.home'),
                    to: this.localePath('/')
                },
                {
                    text: this.$t('drugs.pageTitle'),
                    to: this.localePath('/drugs')
                },
                {
                    text: this.article.name,
                    active: true
                }
            ];
        }
    }
};
</script>
